export const breakTypes = [
  { key: "moderating", label: "Moderating", color: "#5271ff" },
  { key: "meal", label: "Meal Break", color: "#f78e22" },
  { key: "short", label: "Short Break", color: "#f78e22" },
  { key: "training", label: "Training", color: "#c1ff00" },
  { key: "coaching", label: "Coaching", color: "#00b300" },
  { key: "wellbeing", label: "Wellbeing", color: "#00b300" },
  { key: "offline", label: "Offline", color: "#a6a6a6" },
];

export function getBreakTypeDisplay(selectedBreakType) {
  if (selectedBreakType) {
    const selected = breakTypes.find((b) => b.key === selectedBreakType);
    if (!selected) return "";
    if (selected.key === "production") return "On Production";
    return `${selected.label}`;
  }
  return "Select a type to begin";
}

export const AttendanceStatus = {
  CHECKED_IN: "CHECKED_IN",
  CHECKED_OUT: "CHECKED_OUT",
};

export function formatElapsed(seconds) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);

  if (h > 0) {
    return `${h}h ${m} min`;
  } else if (m > 0) {
    return `${m} min`;
  } else {
    return `${seconds}s`;
  }
}

export function formatElapsedDetailed(seconds) {
  const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const s = String(seconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
}
